module.exports = __webpack_public_path__ + "static/media/likeAdded.91aadd20.svg";